import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Row, Col, Typography, Space } from 'antd';

import { QaGridEdit } from 'pages/qa-spec/components';

const QaSpecDocuments = ({
  tableStyle,
  columnDefsJobDocs,
  rowDataQaSpecTemplateDocs,
  qaSpecTemplateDocGridRef,
  onRowSelected,
}) => {
  return (
    <div
      className='qa-spec-doc-n-cer__job-doc'
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 24,
      }}
    >
      <Space direction='vertical' style={{ width: '100%' }}>
        <Row align='bottom' style={{ width: '100%', height: 30 }}>
          <Col span={12}>
            <Typography.Title level={5} strong style={{ marginBottom: 0 }}>
              QA Spec Template Documents
            </Typography.Title>
          </Col>
        </Row>

        <Row style={{ width: '100%' }}>
          <Col span={24}>
            <Row style={{ width: '100%' }}>
              {columnDefsJobDocs && columnDefsJobDocs.length > 0 && (
                <div
                  style={{
                    ...tableStyle,
                    width: '100%',
                  }}
                  className={classnames(
                    'ag-theme-alpine',
                    'ag-theme-alpine--with-scroller'
                  )}
                >
                  <QaGridEdit
                    gridInst={qaSpecTemplateDocGridRef}
                    gridData={rowDataQaSpecTemplateDocs}
                    overlayNoRowsTemplate='No Rows to Show'
                    rowSelection={'single'}
                    onRowSelected={onRowSelected}
                    fields={columnDefsJobDocs}
                    defaultColDef={{ resizable: true }}
                    isEdit={false}
                  />
                </div>
              )}
            </Row>
          </Col>
        </Row>
      </Space>
    </div>
  );
};

QaSpecDocuments.propTypes = {
  tableStyle: PropTypes.object,
  columnDefsJobDocs: PropTypes.array,
  rowDataQaSpecTemplateDocs: PropTypes.array,
  qaSpecTemplateDocGridRef: PropTypes.object,
  onRowSelected: PropTypes.func,
};

export default QaSpecDocuments;
